/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HistoryEventGroupDto } from './HistoryEventGroupDto';
import {
    HistoryEventGroupDtoFromJSON,
    HistoryEventGroupDtoFromJSONTyped,
    HistoryEventGroupDtoToJSON,
    HistoryEventGroupDtoToJSONTyped,
} from './HistoryEventGroupDto';
import type { HistoryEventDto } from './HistoryEventDto';
import {
    HistoryEventDtoFromJSON,
    HistoryEventDtoFromJSONTyped,
    HistoryEventDtoToJSON,
    HistoryEventDtoToJSONTyped,
} from './HistoryEventDto';
import type { GranularityLevelEnum } from './GranularityLevelEnum';
import {
    GranularityLevelEnumFromJSON,
    GranularityLevelEnumFromJSONTyped,
    GranularityLevelEnumToJSON,
    GranularityLevelEnumToJSONTyped,
} from './GranularityLevelEnum';

/**
 * Response containing activity feed history with applied granularity.
 * - For Resume and Complete levels: use 'events' array (groups is null)
 * - For Standard level: use 'groups' array (events is null)
 * 
 * @export
 * @interface GetHistoryByGranularityResponse
 */
export interface GetHistoryByGranularityResponse {
    /**
     * 
     * @type {GranularityLevelEnum}
     * @memberof GetHistoryByGranularityResponse
     */
    granularity: GranularityLevelEnum;
    /**
     * Total number of items (events or groups depending on granularity level)
     * @type {number}
     * @memberof GetHistoryByGranularityResponse
     */
    totalCount: number;
    /**
     * Number of unread events/groups
     * @type {number}
     * @memberof GetHistoryByGranularityResponse
     */
    unreadCount?: number;
    /**
     * List of events (Resume and Complete levels only, null for Standard)
     * @type {Array<HistoryEventDto>}
     * @memberof GetHistoryByGranularityResponse
     */
    events?: Array<HistoryEventDto> | null;
    /**
     * List of event groups (Standard level only, null for Resume and Complete)
     * @type {Array<HistoryEventGroupDto>}
     * @memberof GetHistoryByGranularityResponse
     */
    groups?: Array<HistoryEventGroupDto> | null;
}



/**
 * Check if a given object implements the GetHistoryByGranularityResponse interface.
 */
export function instanceOfGetHistoryByGranularityResponse(value: object): value is GetHistoryByGranularityResponse {
    if (!('granularity' in value) || value['granularity'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function GetHistoryByGranularityResponseFromJSON(json: any): GetHistoryByGranularityResponse {
    return GetHistoryByGranularityResponseFromJSONTyped(json, false);
}

export function GetHistoryByGranularityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHistoryByGranularityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'granularity': GranularityLevelEnumFromJSON(json['granularity']),
        'totalCount': json['totalCount'],
        'unreadCount': json['unreadCount'] == null ? undefined : json['unreadCount'],
        'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(HistoryEventDtoFromJSON)),
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(HistoryEventGroupDtoFromJSON)),
    };
}

export function GetHistoryByGranularityResponseToJSON(json: any): GetHistoryByGranularityResponse {
    return GetHistoryByGranularityResponseToJSONTyped(json, false);
}

export function GetHistoryByGranularityResponseToJSONTyped(value?: GetHistoryByGranularityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'granularity': GranularityLevelEnumToJSON(value['granularity']),
        'totalCount': value['totalCount'],
        'unreadCount': value['unreadCount'],
        'events': value['events'] == null ? undefined : ((value['events'] as Array<any>).map(HistoryEventDtoToJSON)),
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(HistoryEventGroupDtoToJSON)),
    };
}

